export const ACCESS_TOKEN = 'Access-Token'
export const USER_INFO = 'User-info'

export const HOME_PAGE = '/' // 首页路由
